import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const TKIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="TK" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="m1.647 5.032-.443.274.172-.46L1 4.498h.456L1.647 4l.146.498h.457l-.33.348.162.46-.435-.274ZM3.647 3.032l-.443.274.172-.46L3 2.498h.457L3.647 2l.146.498h.457l-.33.348.162.46-.435-.274ZM5.647 5.032l-.443.274.172-.46L5 4.498h.457L5.647 4l.146.498h.457l-.33.348.162.46-.435-.274ZM3.647 7.032l-.443.274.172-.46L3 6.498h.457L3.647 6l.146.498h.457l-.33.348.162.46-.435-.274Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          d="M14.684 9.003 15 9.42l-.316.58-11.377-.22-.152-.418.152-.38 11.377.02ZM12.421 2.73c-.012.018-.986 1.503 0 3.467.992 1.976 1.381 1.841 2.425 2.074H3.671c.02-.014 6.71-4.533 8.75-5.54Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
